import React, { useEffect, useMemo, useState } from "react";
import MainBannerBG from "../../../assets/home-banner-image.svg";
import { TypeAnimation } from "react-type-animation";

function MainBannerSection({ acfData }) {
  const [titles, setTitles] = useState(["One Platform", "Zero Subscriptions"]);

  useEffect(() => {
    if (acfData && Array.isArray(acfData.banner_title_1)) {
      setTitles(acfData.banner_title_1);
    }
  }, [acfData]);

  // Generate sequence for TypeAnimation
  const sequence = useMemo(() => {
    const seq = [];
    titles.forEach((item) => {
      seq.push(item?.banner_title || item);
      seq.push(2000);
    });
    return seq;
  }, [titles]);

  // Generate key to force re-render of TypeAnimation when sequence updates
  const animationKey = useMemo(() => sequence.join("-"), [sequence]);

  return (
    <section
      className="py-14 h-[70vh] bg-contain bg-top-left bg-no-repeat"
      style={{
        backgroundImage: `url(${MainBannerBG})`,
      }}
    >
      <div className="flex flex-col h-full items-center justify-center px-4 mx-auto">
        <div className="flex flex-wrap -mx-4 gap-y-4">
          <div className="w-full max-w-full px-4">
            <h1 className="text-[40px] sm:text-[55px] md:text-[65px] xl:text-[85px] font-normal leading-[1.1177] text-[#181818] tracking-tight">
              <TypeAnimation
                key={animationKey} // force rerender on sequence update
                sequence={sequence}
                wrapper="span"
                speed={50}
                deletionSpeed={70}
                repeat={Infinity}
              />
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainBannerSection;
